import React, { useState } from 'react';
import { userService } from '../services/userService';
import { logService } from '../services/logService';

const Login = ({ onLogin }) => {
  const [view, setView] = useState('SELECT'); // 'SELECT', 'LOGIN', 'SIGNUP'
  const [credentials, setCredentials] = useState({ id: '', pw: '' });
  const [signupForm, setSignupForm] = useState({ name: '', email: '', password: '', role: 'STAFF' });
  const [loading, setLoading] = useState(false);

  const accessLevels = [
    { id: 'STAFF', title: '일반 직원', desc: '고객 응대 및 정비 현황 조회', icon: '💼', color: '#11caa0' },
    { id: 'RECALL', title: '리콜 수행자', desc: '리콜 캠페인 및 이행 기록 관리', icon: '❗', color: '#ff6b00' }
  ];

  const handleRoleClick = (role) => {
    setSignupForm({ ...signupForm, role: role });
    setView('LOGIN');
  };

  const handleLoginSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const result = await userService.login(credentials.id, credentials.pw);
      if (result.success) {
        // 이후 모든 기록에 '등록된 이름'이 수행 작업자로 남도록 먼저 지정한다.
        logService.setOperator(result.user.name);
        logService.record({ module: '시스템', action: 'LOGIN', target: result.user.name, details: '로그인 성공' });
        onLogin(result.user);
      } else {
        alert(result.message);
      }
    } catch (error) {
      alert("로그인 처리 중 오류가 발생했습니다.");
    }
    setLoading(false);
  };

  const handleSignupSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const result = await userService.requestSignup(signupForm);
      if (result.success) {
        alert('✅ 가입 신청이 완료되었습니다. 관리자 승인 후 이용 가능합니다.');
        setView('SELECT');
      } else {
        alert(result.message);
      }
    } catch (error) {
      alert("가입 신청 중 오류가 발생했습니다.");
    }
    setLoading(false);
  };

  const isMobile = window.innerWidth <= 768;

  return (
    <div style={{ 
      display: 'flex', 
      flexDirection: isMobile ? 'column' : 'row', 
      height: '100vh', 
      width: '100vw', 
      background: '#f8fafc', 
      overflow: 'hidden' // 스크롤바가 생겨서 덜컹거리는 현상 방지
    }}>
      
      {/* PC 버전 좌측 고정 사이드 바 배너 */}
      <div style={{ 
        flex: isMobile ? '0' : '1.2', 
        background: '#1e293b', 
        color: 'white', 
        display: isMobile ? 'none' : 'flex', 
        flexDirection: 'column', 
        justifyContent: 'center', 
        alignItems: 'center', 
        padding: '40px' 
      }}>
        <h1 style={{ fontSize: '48px', fontWeight: '900', margin: 0 }}>E2Bility</h1>
        <p style={{ fontSize: '18px', opacity: 0.7, marginTop: '15px' }}>Precision Mobility CRM System</p>
      </div>

      {/* 모바일 버전 전용 상단 로고 탑재 레이아웃 영역 */}
      {isMobile && (
        <div style={{
          background: '#1e293b',
          color: '#ffffff',
          padding: '30px 20px 24px 20px',
          textAlign: 'center',
          borderBottomLeftRadius: '24px',
          borderBottomRightRadius: '24px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
          flexShrink: 0
        }}>
          <h1 style={{ fontSize: '28px', fontWeight: '900', margin: 0, letterSpacing: '0.5px' }}>⚡ E2Bility</h1>
          <p style={{ fontSize: '12px', opacity: 0.6, margin: '6px 0 0 0' }}>Precision Mobility CRM Mobile</p>
        </div>
      )}

      {/* 🚀 메인 폼 바인딩 영역 (모바일에서 수직·수평 정중앙 배치로 리팩토링) */}
      <div style={{ 
        flex: 1, 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', // 🚀 상단 쏠림 현상을 해결하는 완벽한 정중앙 정렬
        padding: '20px',
        boxSizing: 'border-box'
      }}>
        <div style={{ 
          width: '100%', 
          maxWidth: '400px', 
          background: 'white', 
          padding: isMobile ? '30px 20px' : '50px', 
          borderRadius: '24px', 
          boxShadow: '0 10px 30px rgba(0,0,0,0.05)',
          boxSizing: 'border-box',
          transform: isMobile ? 'translateY(-20px)' : 'none' // 🚀 시각적 밸런스를 위한 미세 상단 보정
        }}>
          
          {view === 'SELECT' && (
            <>
              <div style={{ textAlign: 'center', marginBottom: '30px' }}>
                <h2 style={{ fontSize: '20px', fontWeight: '800', color: '#1e293b', margin: 0 }}>반갑습니다!</h2>
                <p style={{ color: '#64748b', fontSize: '13px', marginTop: '8px' }}>접속하실 권한 등급을 선택해주세요.</p>
              </div>
              {accessLevels.map(level => (
                <button key={level.id} onClick={() => handleRoleClick(level.id)} style={{ width: '100%', padding: '16px 20px', marginBottom: '12px', borderRadius: '16px', border: '1px solid #e2e8f0', background: 'white', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '15px', textAlign: 'left', outline: 'none', boxSizing: 'border-box' }}>
                  <span style={{ fontSize: '22px' }}>{level.icon}</span>
                  <div>
                    <div style={{ fontWeight: 'bold', color: '#1e293b', fontSize: '14px' }}>{level.title}</div>
                    <div style={{ fontSize: '11px', color: '#94a3b8', marginTop: '2px' }}>{level.desc}</div>
                  </div>
                </button>
              ))}
              <div style={{ marginTop: '24px', textAlign: 'center' }}>
                <button onClick={() => setView('SIGNUP')} style={{ background: 'none', border: 'none', color: '#11caa0', fontWeight: 'bold', cursor: 'pointer', fontSize: '13px', outline: 'none' }}>신규 계정 가입 신청하기</button>
              </div>
            </>
          )}

          {view === 'LOGIN' && (
            <form onSubmit={handleLoginSubmit}>
              <h2 style={{ fontSize: '20px', fontWeight: '800', textAlign: 'center', marginBottom: '25px', color: '#1e293b' }}>로그인</h2>
              <input style={{ width: '100%', padding: '14px', marginBottom: '12px', borderRadius: '12px', border: '1px solid #e2e8f0', boxSizing: 'border-box', outline: 'none', fontSize: '14px' }} type="email" placeholder="이메일 주소" autoComplete="username" required onChange={e => setCredentials({...credentials, id: e.target.value})} />
              <input style={{ width: '100%', padding: '14px', marginBottom: '20px', borderRadius: '12px', border: '1px solid #e2e8f0', boxSizing: 'border-box', outline: 'none', fontSize: '14px' }} type="password" placeholder="비밀번호" autoComplete="current-password" required onChange={e => setCredentials({...credentials, pw: e.target.value})} />
              <button type="submit" disabled={loading} style={{ width: '100%', padding: '15px', background: loading ? '#94a3b8' : '#1e293b', color: 'white', border: 'none', borderRadius: '12px', cursor: 'pointer', fontWeight: 'bold', marginBottom: '12px', fontSize: '14px' }}>
                {loading ? '로그인 중...' : '로그인 하기'}
              </button>
              <button type="button" onClick={() => setView('SELECT')} style={{ width: '100%', background: 'none', border: 'none', color: '#94a3b8', cursor: 'pointer', fontSize: '13px', outline: 'none' }}>뒤로 가기</button>
            </form>
          )}

          {view === 'SIGNUP' && (
            <form onSubmit={handleSignupSubmit}>
              <p style={{ fontSize: '11px', color: '#11caa0', fontWeight: 'bold', textAlign: 'center', marginBottom: '20px', letterSpacing: '0.5px' }}>REQUEST ACCESS</p>
              <input style={{ width: '100%', padding: '14px', marginBottom: '12px', borderRadius: '12px', border: '1px solid #e2e8f0', boxSizing: 'border-box', outline: 'none', fontSize: '14px' }} placeholder="성함" required onChange={e => setSignupForm({...signupForm, name: e.target.value})} />
              <input style={{ width: '100%', padding: '14px', marginBottom: '12px', borderRadius: '12px', border: '1px solid #e2e8f0', boxSizing: 'border-box', outline: 'none', fontSize: '14px' }} type="email" placeholder="이메일" autoComplete="username" required onChange={e => setSignupForm({...signupForm, email: e.target.value})} />
              <input style={{ width: '100%', padding: '14px', marginBottom: '18px', borderRadius: '12px', border: '1px solid #e2e8f0', boxSizing: 'border-box', outline: 'none', fontSize: '14px' }} type="password" placeholder="비밀번호" autoComplete="new-password" required onChange={e => setSignupForm({...signupForm, password: e.target.value})} />
              <button type="submit" disabled={loading} style={{ width: '100%', padding: '15px', background: loading ? '#94a3b8' : '#11caa0', color: 'white', border: 'none', borderRadius: '12px', cursor: 'pointer', fontWeight: 'bold', fontSize: '14px' }}>
                {loading ? '신청 중...' : '가입 신청하기'}
              </button>
              <button type="button" onClick={() => setView('SELECT')} style={{ width: '100%', background: 'none', border: 'none', color: '#94a3b8', cursor: 'pointer', marginTop: '12px', fontSize: '13px', outline: 'none' }}>취소</button>
            </form>
          )}
          
        </div>
      </div>
    </div>
  );
};

export default Login;